import { useState } from 'react';
import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { Minus, Plus } from '@peacecover/icon';
import type { PhotoCardType } from '../../types/PhotoCardType';

interface ChangeCollectedCountPopupProps {
  onClose: () => void;
  onConfirm: (card: PhotoCardType, collectedCount: number) => void;
  photoCard: PhotoCardType;
}

const ChangeCollectedCountPopup = ({
  onClose,
  onConfirm,
  photoCard
}: ChangeCollectedCountPopupProps) => {
  const [collectedCount, setCollectedCount] = useState(1);
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: 배경(오버레이) 클릭 시 팝업 닫기용 - 버튼이 아닌 영역 클릭 감지 목적
    <div
      className="fixed inset-0 bg-[rgba(0,0,0,0.50)] z-[10001] flex items-center justify-center"
      onClick={onClose}
    >
      {/* biome-ignore lint/a11y/noStaticElementInteractions: 팝업 내부 영역 클릭 시 팝업 닫기 방지 목적 */}
      <div
        className="w-[311px] bg-background-elevated rounded-[20px] pt-[32px] px-[14px] pb-[16px] flex flex-col items-center gap-[40px]"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-[17px] font-bold text-text-main-lv1 text-center whitespace-pre-line">
          {t('CollectionsHomePage.changePhotoCardCount')}
        </p>
        <div className="px-[10px] w-full">
          <div className="flex items-center justify-between px-[12px] py-[14px] rounded-[12px] bg-secondary w-full">
            <button
              type="button"
              onClick={() => setCollectedCount(collectedCount - 1)}
              disabled={collectedCount <= 0}
            >
              <Minus size={20} className="text-on-secondary" />
            </button>
            <p className="text-[17px] font-semibold leading-[20px] text-text-main-lv2">
              {collectedCount}
            </p>
            <button type="button" onClick={() => setCollectedCount(collectedCount + 1)}>
              <Plus size={20} className="text-on-secondary" />
            </button>
          </div>
        </div>
        <Button
          size="large"
          onClick={() => {
            onConfirm(photoCard, collectedCount);
            onClose();
          }}
          className="text-[17px] font-semibold w-full"
        >
          {t('done')}
        </Button>
      </div>
    </div>
  );
};

export default ChangeCollectedCountPopup;
